import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/severity-sla/sla/{-$id}/')({
  // staticData: {
  //   groupingRuleType: GroupingRuleSetTypes.Ticket,
  // },
});
